import type { Address, Contact } from "@jti/fe-common";

import type { SelectedShippingAddress } from "../../ShippingForm.types";

export const propagateContactDataToAddress = (address: SelectedShippingAddress, contact: Contact): Address => {
  return {
    ...address,
    firstname: contact.firstname ?? "",
    lastname: contact.lastname ?? "",
    telephone: contact.telephone ?? "",
  };
};
